export default __webpack_public_path__ + "static/media/danger-tick.57b1a1d2.svg";